import { Resource as s } from "@coveo/platform-client";
const t = class t extends s {
  /**
   * Returns a list of condition objects
   *
   * @returns {Promise<IConditionObjects[]>} List of condition objects.
   */
  getConditionObjects() {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/objects`, {
        organizationId: this.api.organizationId
      })
    );
  }
};
t.baseUrl = "/rest/search/admin/pipelines/config";
let i = t;
export {
  i as ConditionResource
};
//# sourceMappingURL=ConditionResource.js.map
